import API from "../common/API"
import { fetchGet, ErrorCallback } from "../common/Requests"
import { Profile } from "./Profile"

type FetchProfileCallback = (profile: Profile) => void

export function fetchProfile(username: string, handleSuccess: FetchProfileCallback, handleError: ErrorCallback) {
  fetchGet(
    `${API.baseUrl}/api/users/${username}/profile`,
    (json) => {
      handleSuccess(
        Profile.fromResource(json)
      )
    },
    handleError
  )
}
